import { NEW_USER } from "../../analytics/fitAssistantCommon";

export const checkRecommendations = ({
  recommendedSize,
  isPartialRecommendation,
}) =>
  recommendedSize === NEW_USER ||
  (recommendedSize !== NEW_USER && isPartialRecommendation);

export const showSizeAndFit = ({
  sizeAndFitVisible,
  sizeGuideUrl,
  recommendedSize,
  isPartialRecommendation,
}) =>
  sizeAndFitVisible ||
  (sizeGuideUrl && recommendedSize !== null) ||
  checkRecommendations({
    recommendedSize,
    isPartialRecommendation,
  });
